if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"employer","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(321|338|586|758)|2(056|247|359|484|573|712|814)|3((|18|50)8|69)|4((2|37|43)2|046|105|443|526|744|824)|5(14|244|252|616|638)|7(021|276|302)|88(30|8)|92(1|30|80|93)|6456|6904)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}